module.exports = __webpack_public_path__ + "img/input_sequence_phone.93fe4295.png";